module.exports = __webpack_public_path__ + "img/Pelletlager-Reinigung.74db933.png";